<template>
  <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="title" :width="1000">
    <table class="QHtable" v-if="show">
      <tr>
        <th style="width: 150px">基本信息</th>
        <th colspan="10">
          <QHButton A="A74" size="default" @Tap="$refs.edit.hiUpdete(row)" style="float: right" title="信息修改" v-if="isAuth"> 信息修改 </QHButton>
        </th>
      </tr>
      <tr>
        <td><b>船舶编号</b></td>
        <td>{{ row.shipCode }}</td>
        <td style="width: 150px; text-align: center"><b>船舶名称</b></td>
        <td>{{ row.name }}</td>
      </tr>
      <tr>
        <td><b>船舶载量</b></td>
        <td>{{ row.capacity }}</td>
        <td style="text-align: center"><b>船舶登记号</b></td>
        <td>{{ row.registrationNumber }}</td>
      </tr>
      <tr>
        <td><b>船检登记号</b></td>
        <td>{{ row.inspectionRegistrationNumber }}</td>
        <td style="text-align: center"><b>船舶所有人</b></td>
        <td>{{ row.owner }}</td>
      </tr>
      <tr>
        <td><b>船舶经营人</b></td>
        <td>{{ row.operator }}</td>
        <td style="text-align: center"><b>经营人手机</b></td>
        <td>{{ row.phoneNumber }}</td>
      </tr>
      <tr>
        <td><b>经营人许可证号码</b></td>
        <td>{{ row.licenseNumber }}m</td>
        <td style="text-align: center"><b>有效期至</b></td>
        <td>{{ $timeFmt(row.validityPeriod, "YYYY年MM月DD日") }}</td>
      </tr>
      <tr>
        <td><b>船舶总长</b></td>
        <td>{{ row.totalLength }}m</td>
        <td style="text-align: center"><b>船舶长度</b></td>
        <td>{{ row.length }}m</td>
      </tr>
      <tr>
        <td><b>船舶宽度</b></td>
        <td>{{ row.width }}m</td>
        <td style="text-align: center"><b>船舶型深</b></td>
        <td>{{ row.depth }}m</td>
      </tr>
      <tr>
        <td><b>最大船高</b></td>
        <td>{{ row.maxHeight }}m</td>
        <td style="text-align: center"><b>空载吃水</b></td>
        <td>{{ row.lightDraft }}m</td>
      </tr>
      <tr>
        <td><b>满载吃水</b></td>
        <td>{{ row.fullDraft }}m</td>
        <td style="text-align: center"><b>船舶状态</b></td>
        <td>
          <span v-if="row.status == 100">使用中</span>
          <span v-if="row.status == 200">未使用</span>
        </td>
      </tr>
      <!-- 资质证件部分保持不变 -->
      <tr>
        <th>资质证件</th>
        <th colspan="10">
          <QHButton A="A222" size="default" style="float: right" @Tap="$refs.setQualification.hiCreated(row.id, 700)" v-if="isAuth"> 资质上传 </QHButton>
        </th>
      </tr>
      <tr v-if="!row.information700">
        <td colspan="10">暂无证件资质信息</td>
      </tr>
      <tr v-for="(item, index) in row.information700" :key="index">
        <td>
          <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
        </td>
        <td colspan="10">
          <div class="flex-between">
            <div>
              <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
              <span class="MR5 CL5" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
              <span>{{ item.name }}</span>
              <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
            </div>
            <div class="flex-between" style="margin-left: 10px">
              <span class="QHset" style="white-space: nowrap" @click="$refs.setQualification.hiUpdete(item.id)" v-if="isAuth"> 修改 </span>
              <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              <span class="QHset CL1" style="white-space: nowrap" @click="deleteData(item.id)" v-if="isAuth"> 删除 </span>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </Modal>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      title: "船舶详情",
      show: false,
      isAuth: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:唤起修改
    // +----------------------------------------------------------------------
    hiPop(e, isAuth) {
      this.isAuth = isAuth;
      this.$loading(true);
      this.$api.getShipDetailed({ id: e.id }).then((res) => {
        this.$loading(false);
        if (res.code == 0) {
          this.row = res.data;
          this.show = true;
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    // +----------------------------------------------------------------------
    // | Desc:开始清运
    // +----------------------------------------------------------------------
    deleteData(id) {
      //请求入库
      var that = this;
      var confirm = {
        title: "删除资质",
        msg: "<p>一旦删除就不可撤销，只能重新上传！</p>",
      };
      this.$confirm(confirm, function () {
        //参数整合与接口
        var https = {
          isLoading: "isLoadingPop",
          api: that.$api.removeShipQualification,
          parameter: {
            id: id,
          },
          successMsg: "删除成功",
        };
        that.$httpsApi(
          https,
          function (res) {
            that.hiPop(that.row, that.isAuth);
            that.$emit("success");
          },
          function (res) {
            that.$alert(res.msg);
          }
        );
      });
    },
  },
};
</script>
